module.exports = __webpack_public_path__ + "242917f40136c1857a4bd2069bd08859.jpg";